import { getAllocationUtils } from './utils';
import sortByPrice from './sortByPrice';
import { hourlyBannerGuest } from './hourlyBannerUserAndGuest';

const experiments = {
    sortByPrice,
    hourlyBannerGuest,
};

export const clientExperiments = getAllocationUtils(experiments);
